import React from 'react'
import { useTranslation } from 'react-i18next'

import ProductFilterForm from './filter-form'



const ProductsFilters = ({ categories, purposes, intendedMaterials, handleFilters, applyFilters, initialFilters }) => {
  const { t } = useTranslation()

  return (
    <div className="products-filter">
      <div className="products-filter-slogan">
        <span>{t("find a product for yourself")}</span>
      </div>
      <div className="products-filter-box">
        <div className="products-filter-box-forms">
          {categories && 
            <ProductFilterForm
              title={t("Product category")}
              data={categories}
              taxonomyName="category"
              initialFilters={initialFilters}
              handleChange={v => handleFilters(v)}
            />
          }
          {intendedMaterials &&
            <ProductFilterForm
              title={t("Intended material")}
              data={intendedMaterials}
              taxonomyName="intended"
              initialFilters={initialFilters}
              handleChange={v => handleFilters(v)}
              columns={2}
            />
          }
          {purposes &&
            <ProductFilterForm
              title={t("Purpose")}
              data={purposes}
              taxonomyName="purpose"
              initialFilters={initialFilters}
              handleChange={v => handleFilters(v)}
            />
          }
        </div>
        <div className="products-filter-box-summary">
          <div className="btn btn-right-skew btn-dark" onClick={applyFilters}>{t("Apply filters")}</div>
        </div>
      </div>
    </div>
  )
}

export default ProductsFilters